// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 7) return "static/css/7.f3ad8c16.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}